/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vital } from '../../models/vital';

export interface VitalGetGraphForVital$Params {
  emrpracticeId?: string | null;
  PatientId?: string | null;
  vitalname?: string | null;
}

export function vitalGetGraphForVital(http: HttpClient, rootUrl: string, params?: VitalGetGraphForVital$Params, context?: HttpContext): Observable<StrictHttpResponse<Vital>> {
  const rb = new RequestBuilder(rootUrl, vitalGetGraphForVital.PATH, 'get');
  if (params) {
    rb.query('emrpracticeId', params.emrpracticeId, {});
    rb.query('PatientId', params.PatientId, {});
    rb.query('vitalname', params.vitalname, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vital>;
    })
  );
}

vitalGetGraphForVital.PATH = '/vital/graph';
